module.exports = __webpack_public_path__ + "img/pic1.7130f29.png";